import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import useModalQueryParam from 'hooks/useModalQueryParam';
import Stack from 'components/Stack';
import Button from 'components/Button';
import EmptyStateController from 'components/EmptyStateController';
import PageSection from 'components/PageSection';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import PlaylistEditorModal, { useSubmitPlaylistCreator } from 'screens/PlaylistEditorModal';
import TeamAccessWrapper from '../../../shared/TeamAccessWrapper';
import SmartContentCard from '../../../shared/smartContentCard';
import { useFetchPlaylists } from 'actions/playlists';
export var ADD_PLAYLIST_QUERY_PARAM = 'add-playlist';
function MyTeamPlaylists() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var history = useHistory();
  // Get the teamId from the URL (/my-teams/:teamId)
  var _useParams = useParams(),
    teamId = _useParams.teamId;
  var _useFetchPlaylists = useFetchPlaylists(teamId),
    playlists = _useFetchPlaylists.playlists,
    isLoading = _useFetchPlaylists.isLoading,
    isError = _useFetchPlaylists.isError;
  var _useModalQueryParam = useModalQueryParam(ADD_PLAYLIST_QUERY_PARAM),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasPlaylistEditorModal = _useModalQueryParam2[0],
    togglePlaylistEditorModal = _useModalQueryParam2[1];
  var _useSubmitPlaylistCre = useSubmitPlaylistCreator({
      ownerTeamId: Number(teamId),
      onSuccess: function onSuccess(newPlaylistId) {
        togglePlaylistEditorModal();
        history.push("/playlists/".concat(newPlaylistId));
      }
    }),
    submitPlaylistCreation = _useSubmitPlaylistCre.submitPlaylistCreation;
  return /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xl"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "important",
    icon: "plus",
    onClick: togglePlaylistEditorModal
  }, t('actions_add_playlist')), hasPlaylistEditorModal && /*#__PURE__*/React.createElement(PlaylistEditorModal, {
    onSubmit: submitPlaylistCreation,
    onClose: togglePlaylistEditorModal
  })), /*#__PURE__*/React.createElement(EmptyStateController, {
    data: playlists,
    isLoading: isLoading,
    isError: isError,
    height: 300
  }, /*#__PURE__*/React.createElement(CollectionGrid, null, playlists.map(function (playlist) {
    return /*#__PURE__*/React.createElement(CollectionGridItem, {
      key: playlist.id
    }, /*#__PURE__*/React.createElement(SmartContentCard, {
      content: playlist,
      thumbnailDimensions: "w_757,h_150"
    }));
  })))));
}
function ProtectedMyTeamPlaylists() {
  return /*#__PURE__*/React.createElement(TeamAccessWrapper, {
    getAdditionalPermissions: function getAdditionalPermissions() {
      return !!hasPrivilege(PLAYLIST_WRITE);
    }
  }, /*#__PURE__*/React.createElement(MyTeamPlaylists, null));
}
export default ProtectedMyTeamPlaylists;